import {useCallback, useContext, useMemo} from "react";
import {notification} from "antd"
import {Api} from "@resources/api/Api";
import {GlobalContext} from "@tools/globalContext";
import * as Errors from "@resources/Errors";
import {EErrors} from "@interface/enums";
import type{IApiGeneratorConfig} from "@tools/CustomInterfaces";

interface Props {
    config? : IApiGeneratorConfig[]
}

const useApi = (props: Props = {}) => {
    const {config} = props;
    const {token, sid } = useContext(GlobalContext);

    const api = useMemo(() => {
        return new Api({baseApiParams: {headers : {authorization : `Bearer ${token}`, sid}}})
    }, [Api, token])

    const showServerError = useCallback((e) => {
        debugger
        let message = e.error?.message || e.message
        const title = e.statusText ? `${e.statusText} ${e.error?.error || ""}`: "ServerError"
        if(message === "Unexpected token P in JSON at position 0") {
            // message = await e.text()
        }

        if (e.error === Errors.itemWithRelation().error)
            return

        notification.error({
            message: title,
            description: message || e.statusText,
            duration: 0
        });
    }, [])

    const crudApi = useMemo(() => {
        return (config || []).reduce((res: {[key: string] : any}, item) => {
            //@ts-ignore
            const tagApis = api[item.tag]
            if (!tagApis) {
                console.error(`Missing API tag, ${item.tag}`);
                return res;
            }
            if (!tagApis[item.value]) {
                debugger
                console.error(`Missing API function, ${item.tag}/${item.value}`);
                return res;
            }

            res[item.name] = async (query: any, options?: {hideErrorMessage?: EErrors[]}) => {
                try {
                    const dbData = await tagApis[item.value](Object.assign({}, query, item.searchSettings || {}));

                    if(dbData?.status === 200 && !dbData.data && !dbData.error )
                        return dbData

                    if (dbData.error?.code === Errors.invalidToken().code) {
                        return window.location.reload()
                    }
                    if (dbData.error) {
                        if (!options?.hideErrorMessage?.includes(dbData.error))
                            showServerError(dbData)
                        return dbData.error
                    }
                    if (dbData.data.error){
                        if (!options?.hideErrorMessage?.includes(dbData.data.error))
                            showServerError(dbData.data);
                    }
                    if (dbData.data)
                        return dbData.data;
                } catch(e : any) {
                    showServerError(e)
                    debugger
                    return {message : e.error?.message || e.statusText, error: e.error?.error || -200, code: e.status}
                }

            }
            return res
        }, {})
    }, [api, config, showServerError])

    return {api, crudApi, showServerError}
}

export default useApi;
